import validator from 'validator';

/** Minimal control shape; matches Angular AbstractControl for `value` usage. */
export interface EmailControlLike {
  value?: string | null;
}

export function emailValidator() {
  return (control: EmailControlLike): { email: { value: string } } | null => {
    return !control.value || validator.isEmail(control.value)
      ? null
      : { email: { value: control.value } };
  };
}
